import { render, staticRenderFns } from "./employee.vue?vue&type=template&id=6157280c&scoped=true"
import script from "./employee.vue?vue&type=script&lang=js"
export * from "./employee.vue?vue&type=script&lang=js"
import style0 from "./employee.vue?vue&type=style&index=0&id=6157280c&prod&lang=scss&scoped=true"
import style1 from "./employee.vue?vue&type=style&index=1&id=6157280c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6157280c",
  null
  
)

export default component.exports